import { getCustomerInfo } from './shared/service/bc';
import {
  checkIfCompanyHasAccessToFeature,
  fetchAllCompanyAddresses,
  KOBE_PORTAL_FEATURE_ACCESS,
  sendCustomCartData,
} from './shared/service/myintegrator/api/global';
import { CompanyState } from './store/slices/company';
import {
  // bindLinks,
  initApp,
  // requestIdleCallbackFunction,
  // unbindLinks
} from './load-functions';
import { AddressItemType } from './types';

// // check if the accesed url contains a hashtag or checkout (to speed up process on loading css) - Steven
// if (window.location.hash.startsWith('#/') || window.location.href.includes('/checkout')) {
//   initApp();
// } else {
//   // load the app when the browser is free
//   requestIdleCallbackFunction(initApp);
//   // and bind links to load the app
//   bindLinks();
//   window.addEventListener('beforeunload', unbindLinks);
//   // and observe global flag to simulate click
//   window.b2b.initializationEnvironment.isInitListener = () => {
//     unbindLinks();
//     setTimeout(() => window.b2b.initializationEnvironment.clickedLinkElement?.click(), 0);
//   };
// }

initApp();

// function attachOrderCommentListener() {
//   const input = document.getElementById('myship-customer-comment-field') as HTMLInputElement | null;

//   if (!input) return;

//   input.addEventListener('focus', () => {
//     const continueBtn = document.getElementById(
//       'checkout-payment-continue',
//     ) as HTMLButtonElement | null;
//     if (continueBtn) {
//       continueBtn.disabled = true;
//     }
//   });

//   input.addEventListener('blur', async () => {
//     const cartId = Cookies.get('cartId');
//     if (!cartId) return;

//     const newMessage = input.value;

//     try {
//       const response = await fetch(`/api/storefront/checkouts/${cartId}`, {
//         method: 'PUT',
//         credentials: 'include',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//         },
//         body: JSON.stringify({ customerMessage: newMessage }),
//       });

//       if (!response.ok) {
//         console.error('Failed to update customerMessage');
//       }

//       window.location.reload();
//     } catch (error) {
//       console.error('Error updating customerMessage:', error);
//     }
//   });
// }

// function injectOrderCommentFieldset() {
//   // Avoid duplicate insertion
//   if (document.getElementById('myship-customer-comment-field')) return;

//   const formActions = document.querySelector('li.checkout-step--payment .form-actions');
//   if (!formActions) return;

//   const fieldset = document.createElement('fieldset');
//   fieldset.className = 'form-fieldset';

//   fieldset.innerHTML = `
//     <legend class="form-legend optimizedCheckout-headingSecondary">
//       Order Comments
//     </legend>
//     <div class="form-body">
//       <div class="form-field">
//         <label for="orderComment"
//           class="form-label is-srOnly optimizedCheckout-form-label">
//           Order Comments
//         </label>
//         <input autocomplete="off" id="orderComment" maxlength="2000" type="text"
//           class="form-input optimizedCheckout-form-input"
//           name="orderComment" value="" data-note-added="true"
//           style="visibility: hidden; height: 0; padding: 0;">
//         <div>
//           Add any special instructions for the warehouse team.
//         </div>
//         <input autocomplete="off"
//           id="myship-customer-comment-field"
//           maxlength="2000" type="text"
//           class="form-input optimizedCheckout-form-input"
//           name="myship-customer-comment" value=""
//           data-note-added="true">
//       </div>
//     </div>
//   `;

//   // Insert just before the form actions container
//   formActions.parentElement?.insertBefore(fieldset, formActions);

//   // Attach update listener in case called directly
//   attachOrderCommentListener();
// }

// let hasFetchedCustomerMessage = false;
// async function fetchAndInjectCustomerMessage(): Promise<void> {
//   if (hasFetchedCustomerMessage) return; // Prevent multiple calls
//   hasFetchedCustomerMessage = true;

//   const cartId = Cookies.get('cartId');
//   if (!cartId) return;

//   try {
//     const response = await fetch(`/api/storefront/checkouts/${cartId}`, {
//       method: 'GET',
//       credentials: 'include',
//       headers: {
//         Accept: 'application/json',
//       },
//     });

//     if (!response.ok) {
//       console.error('Failed to fetch checkout data');
//       return;
//     }

//     const data = await response.json();
//     const message = data?.customerMessage || '';

//     injectOrderCommentFieldset();

//     const input = document.getElementById(
//       'myship-customer-comment-field',
//     ) as HTMLInputElement | null;
//     if (input && message) {
//       input.value = message;
//     }

//     attachOrderCommentListener();
//   } catch (err) {
//     console.error('Error fetching customer message:', err);
//   }
// }

function addCommaAfterThankYou() {
  const observer = new MutationObserver(() => {
    const h1 = document.querySelector('h1[data-test="order-confirmation-heading"]');
    if (!h1) return;

    if (!h1.textContent) return;

    const txt = h1.textContent.trim();
    if (txt.startsWith('Thank you') && !txt.startsWith('Thank you,')) {
      h1.textContent = txt.replace(/^Thank you\b/, 'Thank you,');
    }

    observer.disconnect(); // remove if you only want it once
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function observeAndHideShippingComments() {
  // Function to hide the fieldset inside the shipping step
  function hideFieldset() {
    const shippingStepSelector = 'li.checkout-step--shipping';
    const fieldsetSelector = 'fieldset.form-fieldset[data-test="checkout-shipping-comments"]';

    const shippingStep = document.querySelector(shippingStepSelector);
    if (!shippingStep) return;
    const fieldset = shippingStep.querySelector(fieldsetSelector) as HTMLElement;
    if (fieldset && fieldset.style.display !== 'none') {
      fieldset.style.display = 'none';
    }
  }

  // Initial hide on load if already present
  hideFieldset();

  // Observe changes inside the shipping step only
  const observer = new MutationObserver(() => {
    hideFieldset();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

const CART_LINK_ID = 'cart-edit-link';
const TARGET_HREF = '/consumables';

function updateCartLinkIfPresent(): boolean {
  const link = document.getElementById(CART_LINK_ID) as HTMLAnchorElement | null;
  if (!link) return false;

  // Only rewrite if it's the cart.php link
  const current = link.getAttribute('href') ?? '';
  if (current.includes('cart.php')) {
    link.setAttribute('href', TARGET_HREF);
  }
  return true;
}

function initCartLinkOverride() {
  // Try immediately in case it's already there
  if (updateCartLinkIfPresent()) return;

  // Otherwise watch for it
  const observer = new MutationObserver(() => {
    const updated = updateCartLinkIfPresent();
    if (updated) {
      observer.disconnect();
    }
  });

  // Observe the whole document; tweak if you know the exact container
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// function observeAndRemoveCartEditLink() {
//   const selector = '#cart-edit-link';

//   function removeLink() {
//     const link = document.querySelector(selector);
//     if (link && link.parentNode) {
//       link.remove();
//     }
//   }

//   // Ensure body exists before observing
//   function initObserver() {
//     const body = document.body;
//     if (!body) {
//       // Retry once DOM is ready
//       window.addEventListener('DOMContentLoaded', initObserver, { once: true });
//       return;
//     }

//     // Initial removal
//     removeLink();

//     // Observe DOM for reinsertions
//     const observer = new MutationObserver(() => removeLink());
//     observer.observe(body, { childList: true, subtree: true });
//   }

//   initObserver();
// }

function hidePaymentInstruction() {
  function hideOrderConfirmationsWithPaymentInstructions() {
    document.querySelectorAll('.orderConfirmation-section').forEach((section) => {
      const el = section as HTMLElement;
      if (el.querySelector('[data-test="payment-instructions"]')) {
        el.style.display = 'none';
      }
    });
  }

  // Initial run
  hideOrderConfirmationsWithPaymentInstructions();

  // Observe for dynamically added sections
  const observer = new MutationObserver(() => {
    hideOrderConfirmationsWithPaymentInstructions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function observerQueenslandSignature() {
  const b2bCompanyData = sessionStorage.getItem('b2b-kobe-company-data');
  const kobeCartType = sessionStorage.getItem('kobe-cart-type');
  const pathology = sessionStorage.getItem('company-pathology');
  if (!b2bCompanyData || !kobeCartType) return;
  if (!pathology || pathology.toLowerCase() !== 'qml') return;
  if (!kobeCartType || kobeCartType !== 'vaccines') return;

  function buildSignatureStep(): HTMLElement {
    const li = document.createElement('li');
    li.className = 'checkout-step optimizedCheckout-checkoutStep checkout-step--vaccine';
    li.setAttribute('data-injected-signature-step', 'true');
    li.innerHTML = `
      <div class="checkout-view-header">
        <div class="stepHeader is-readonly">
          <div class="stepHeader-figure stepHeader-column">
            <div class="icon stepHeader-counter optimizedCheckout-step">
              <svg height="24" viewBox="0 0 24 24" width="24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>
            </div>
            <h2 class="stepHeader-title optimizedCheckout-headingPrimary">Signature</h2>
          </div>
          <div class="stepHeader-body stepHeader-column optimizedCheckout-contentPrimary" data-test="step-info"></div>
        </div>
      </div>
      <div class="checkout-view-content" style="margin-top:10px;">
        <p>To comply with the Medicines and Poisons (Medicines) Regulation 2021 (Queensland), a clinician or doctor must sign this order electronically by including the required information listed below.</p>
        <fieldset class="form-fieldset" style="display:flex;gap:10px;">
          <div class="form-field" style="width:100%;">
            <label class="form-label optimizedCheckout-form-label" for="doctor-name">Doctor name (required)</label>
            <input class="form-input optimizedCheckout-form-input" id="doctor-name" type="text" required>
          </div>
          <div class="form-field" style="width:100%;">
            <label class="form-label optimizedCheckout-form-label" for="provider-number">Provider number</label>
            <input class="form-input optimizedCheckout-form-input" id="provider-number" type="text" required>
          </div>
        </fieldset>
      </div>
    `;
    return li;
  }

  const isSignatureValid = (): boolean => {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    return !!(
      doctorInput &&
      providerInput &&
      doctorInput.value.trim() &&
      providerInput.value.trim()
    );
  };

  const signatureValues = (): string => {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    if (doctorInput && providerInput && doctorInput.value.trim() && providerInput.value.trim()) {
      return JSON.stringify({
        doctor_number: doctorInput.value.trim(),
        provider_number: providerInput.value.trim(),
      });
    }
    return '';
  };

  // UPDATED: stronger validation binding
  function bindValidation(): void {
    const doctorInput = document.querySelector<HTMLInputElement>('#doctor-name');
    const providerInput = document.querySelector<HTMLInputElement>('#provider-number');
    if (!doctorInput || !providerInput) return;

    const applyState = () => {
      // Re-select button each time (React may swap it)
      const btn = document.querySelector<HTMLButtonElement>('#checkout-payment-continue');
      if (!btn) return;
      const ok = isSignatureValid();
      if (ok) {
        const SIGNATURE_KEY = 'doctor_signature_payload';
        const lastPayload = sessionStorage.getItem(SIGNATURE_KEY) || '';
        const currentPayload = signatureValues();
        if (currentPayload !== lastPayload) {
          sendCustomCartData('doctor_signature', currentPayload);
          sessionStorage.setItem(SIGNATURE_KEY, currentPayload);
        }
        btn.disabled = false;
        btn.removeAttribute('disabled'); // kill attribute too
        btn.setAttribute('aria-disabled', 'false');
      } else {
        btn.disabled = true;
        btn.setAttribute('disabled', ''); // keep disabled firmly
        btn.setAttribute('aria-disabled', 'true');
      }
    };

    // input listeners (bind once)
    if (!doctorInput.dataset.validationBound) {
      const revalidate = () => applyState();
      doctorInput.addEventListener('input', revalidate);
      providerInput.addEventListener('input', revalidate);
      doctorInput.dataset.validationBound = 'true';
      providerInput.dataset.validationBound = 'true';
    }

    // backstop: block click/submit if not valid
    const btn = document.querySelector<HTMLButtonElement>('#checkout-payment-continue');
    if (btn && !btn.dataset.signatureGuardBound) {
      btn.addEventListener(
        'click',
        (e) => {
          if (!isSignatureValid()) {
            e.preventDefault();
            e.stopPropagation();
            applyState();
          }
        },
        true,
      ); // capture to beat other handlers
      btn.dataset.signatureGuardBound = 'true';
    }

    // initial state
    applyState();
  }

  function ensureInserted(): void {
    const paymentStep = document.querySelector<HTMLElement>(
      'li.checkout-step.optimizedCheckout-checkoutStep.checkout-step--payment',
    );
    if (!paymentStep) return;

    let existing = document.querySelector<HTMLElement>(
      'li.checkout-step--vaccine[data-injected-signature-step]',
    );
    if (!existing) {
      existing = buildSignatureStep();
      paymentStep.parentNode?.insertBefore(existing, paymentStep);
    } else if (existing.nextElementSibling !== paymentStep) {
      paymentStep.parentNode?.insertBefore(existing, paymentStep);
    }

    bindValidation();
  }

  ensureInserted();

  // Also re-validate on DOM churn (button swaps, etc.)
  const observer = new MutationObserver(() => {
    ensureInserted();
    // If only the button was replaced, ensure validation reapplies
    const btn = document.querySelector('#checkout-payment-continue');
    if (btn) (btn as HTMLButtonElement).disabled = !isSignatureValid();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// function observeCheckoutForOrderComments() {
//   const checkoutContainer = document.body;

//   const observer = new MutationObserver(() => {
//     const paymentStep = document.querySelector('li.checkout-step--payment .stepHeader.is-readonly');
//     const checkoutPaymentContinue = document.querySelector('#checkout-payment-continue');

//     if (paymentStep && checkoutPaymentContinue) {
//       fetchAndInjectCustomerMessage();
//     }
//   });

//   observer.observe(checkoutContainer, {
//     childList: true,
//     subtree: true,
//   });
// }

function replaceEmail() {
  const NEW_EMAIL = 'practice@medway.com.au';

  const observer = new MutationObserver(() => {
    const a = document.querySelector('a[href^="mailto:stephane.recouvreur@healius.com.au"]');
    if (!a) return;

    // Preserve query string (e.g. ?Subject=Order 119)
    const href = a.getAttribute('href');
    if (href) {
      const query = href.split('?')[1] || '';
      a.setAttribute('href', `mailto:${NEW_EMAIL}${query ? `?${query}` : ''}`);
    }

    // Update visible text
    if (a.textContent && a.textContent.trim() === 'stephane.recouvreur@healius.com.au') {
      a.textContent = NEW_EMAIL;
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
function replaceContinueShopping() {
  const observer = new MutationObserver(() => {
    const btn = document.querySelector('.continueButtonContainer form button');
    if (!btn) return;

    if (btn.textContent) {
      btn.textContent = 'Back to Medway Practice';
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function replaceConfirmationStatusText() {
  const observer = new MutationObserver(() => {
    const spanElement = document.querySelector(
      'p[data-test="order-confirmation-order-status-text"] span',
    );
    if (!spanElement) return;

    if (spanElement.textContent) {
      spanElement.textContent = 'Your order has been received. Thank you for your business.';
    }

    observer.disconnect(); // stop once updated
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function hideShippingFieldset() {
  const observer = new MutationObserver(() => {
    const fs = document.getElementById('checkout-shipping-options');
    if (fs) {
      fs.style.display = 'none';
      // leave observer running if the element gets re-added
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function hideBillingStep() {
  const observer = new MutationObserver(() => {
    const billingStep = document.querySelector('.checkout-step--billing') as HTMLElement | null;
    if (billingStep && billingStep.style.display !== 'none') {
      billingStep.style.display = 'none';
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function injectCustomSubmitButton() {
  let observedOriginalBtn: HTMLButtonElement | null = null;
  const attrObserver = new MutationObserver(() => {
    const customBtn = document.getElementById(
      'custom-checkout-payment-continue',
    ) as HTMLButtonElement | null;
    if (observedOriginalBtn && customBtn) {
      customBtn.disabled = observedOriginalBtn.disabled;
      if (observedOriginalBtn.disabled) {
        customBtn.setAttribute('disabled', '');
      } else {
        customBtn.removeAttribute('disabled');
      }
    }
  });

  const observer = new MutationObserver(() => {
    // 1. Hide the original button
    const originalBtn = document.querySelector(
      '#checkout-payment-continue',
    ) as HTMLButtonElement | null;
    if (originalBtn) {
      if (originalBtn.style.display !== 'none') {
        originalBtn.style.display = 'none';
      }
      if (originalBtn !== observedOriginalBtn) {
        if (observedOriginalBtn) {
          attrObserver.disconnect();
        }
        observedOriginalBtn = originalBtn;
        attrObserver.observe(originalBtn, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
        });
      }
    }

    // 2. Insert the custom button after cart-total
    const cartTotalNode = document.querySelector('[data-test="cart-total"]');
    if (!cartTotalNode) return;

    let customBtn = document.getElementById(
      'custom-checkout-payment-continue',
    ) as HTMLButtonElement | null;
    if (!customBtn) {
      customBtn = document.createElement('button');
      customBtn.id = 'custom-checkout-payment-continue';
      customBtn.className =
        'button button--action button--large button--slab optimizedCheckout-buttonPrimary';
      customBtn.type = 'button';
      customBtn.style.width = '100%';
      customBtn.style.marginTop = '3rem';
      customBtn.textContent = 'Submit order';

      customBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const realBtn = document.querySelector(
          '#checkout-payment-continue',
        ) as HTMLButtonElement | null;
        if (realBtn) {
          realBtn.click();
        }
      });

      cartTotalNode.parentNode?.insertBefore(customBtn, cartTotalNode.nextSibling);
    }

    // 3. Sync initial state
    if (originalBtn && customBtn) {
      customBtn.disabled = originalBtn.disabled;
      if (originalBtn.disabled) {
        customBtn.setAttribute('disabled', '');
      } else {
        customBtn.removeAttribute('disabled');
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function styleSeeAllButton() {
  const observer = new MutationObserver(() => {
    const buttons = document.querySelectorAll<HTMLButtonElement>(
      'button.button--tertiary.button--tiny.optimizedCheckout-buttonSecondary',
    );

    buttons.forEach((btn) => {
      // Find text nodes to replace content surgically
      let foundTarget = false;
      btn.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent) {
          const text = node.textContent.trim();
          if (text === 'See All') {
            // eslint-disable-next-line no-param-reassign
            node.textContent = node.textContent.replace('See All', 'See all');
            foundTarget = true;
          } else if (text === 'See Less') {
            // eslint-disable-next-line no-param-reassign
            node.textContent = node.textContent.replace('See Less', 'See less');
            foundTarget = true;
          }
        }
      });

      if (foundTarget && !btn.dataset.styled) {
        /* eslint-disable no-param-reassign */
        btn.style.backgroundColor = 'transparent';
        btn.style.border = 'none';
        btn.style.color = '#033572';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.width = '100%';
        btn.style.gap = '5px';

        const svg = btn.querySelector('svg');
        if (svg) {
          svg.setAttribute('fill', '#033572');
        }
        btn.dataset.styled = 'true';
        /* eslint-enable no-param-reassign */
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function watchForAddresses() {
  function readAddresses() {
    const raw = sessionStorage.getItem('kobe-company-addresses');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Invalid JSON in sessionStorage:', err);
      return null;
    }
  }

  // helper: get index of an LI within its list
  function indexOfLi(container: HTMLElement, li: Element): number {
    const items = Array.from(container.querySelectorAll('li.dropdown-menu-item'));
    return items.indexOf(li as HTMLElement);
  }

  // Run immediately in case elements already exist
  const observer = new MutationObserver(() => {
    if (document.getElementById('shippingAddresses')) {
      const shipping = document.getElementById('shippingAddresses');
      const addresses = readAddresses();
      const shippingAddresses = addresses
        ? addresses
            .filter((a: AddressItemType) => a.isActive === 1 && a.isShipping === 1)
            .sort((a: AddressItemType, b: AddressItemType) => Number(a.id) - Number(b.id))
        : [];
      if (shipping && shippingAddresses.length > 0) {
        const addressDropdownItems = shipping.querySelectorAll('li.dropdown-menu-item');
        addressDropdownItems.forEach((li, i) => {
          const fnEntry = li.querySelector('.fn.address-entry');
          if (fnEntry && shippingAddresses[i]) {
            // check if a label already exists
            if (!li.querySelector('.address-label')) {
              const newP = document.createElement('p');
              newP.className = 'address-entry address-label';
              newP.style.fontWeight = '700';
              newP.textContent = shippingAddresses[i].label; // or shippingAddresses[i].property
              fnEntry.before(newP);
            }
          }
        });

        // --- Selected shipping block (default shipping only) ---
        const selectedShippingAddress = sessionStorage.getItem(`kobe-shipping-selected-address`);
        let defaultShipping = null;
        if (selectedShippingAddress) {
          defaultShipping = JSON.parse(selectedShippingAddress);
        } else {
          defaultShipping = shippingAddresses.find(
            (a: AddressItemType) => a.isDefaultShipping === 1,
          );
        }
        if (defaultShipping?.label) {
          const selected = shipping.querySelector('.dropdownTrigger .fn.address-entry');
          if (selected && !selected.parentElement?.querySelector('.address-label')) {
            const newP = document.createElement('p');
            newP.className = 'address-entry address-label';
            newP.style.fontWeight = '700';
            newP.style.display = 'block';
            newP.textContent = defaultShipping.label;
            selected.before(newP);
          }
        }

        // CLICK: update selected label when a list item is chosen
        shipping.addEventListener(
          'click',
          (ev) => {
            const li = (ev.target as HTMLElement).closest('li.dropdown-menu-item');
            if (!li) return;
            const idx = indexOfLi(shipping, li);
            const addr = shippingAddresses[idx];
            sessionStorage.setItem(`kobe-shipping-selected-address`, JSON.stringify(addr));
          },
          { once: false },
        );
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// ─── Checkout Address Injection ──────────────────────────────────────────────

/**
 * Watches for the shipping form to appear/reappear in the checkout DOM.
 * Uses a WeakSet to avoid processing the same form element twice.
 */
function watchShippingStep(callback: (form: Element) => void) {
  const observedElements = new WeakSet<Element>();

  const process = () => {
    document.querySelectorAll('.checkout-step--shipping .checkout-form').forEach((form) => {
      if (!observedElements.has(form)) {
        observedElements.add(form);
        callback(form);
      }
    });
  };

  const observer = new MutationObserver(() => process());
  observer.observe(document.body, { childList: true, subtree: true });

  // Run once immediately in case the element is already loaded
  process();

  return observer;
}

/**
 * Maps a raw B2B API address object to the display fields expected by
 * buildAddressItem and updateStaticAddress.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toDisplayAddr(raw: any) {
  return {
    label: `Company: ${raw.companyName}` || '',
    firstName: raw.firstName || '',
    lastName: raw.lastName || '',
    company: raw.company || '',
    addressLine1: raw.addressLine1 || '',
    addressLine2: raw.addressLine2 || '',
    city: raw.city || '',
    state: raw.stateCode || raw.stateName || raw.state || '',
    zipCode: raw.zipCode || '',
    country: raw.countryName || raw.country || '',
    phoneNumber: raw.phoneNumber || '',
  };
}

/**
 * Builds an address <li> element matching the BigCommerce checkout dropdown structure.
 */
function buildAddressItem(addr: ReturnType<typeof toDisplayAddr>): HTMLLIElement {
  const li = document.createElement('li');
  li.className = 'dropdown-menu-item dropdown-menu-item--select';
  li.setAttribute('data-test', 'address-select-option');

  const addressLine2Html = addr.addressLine2
    ? `<p class="street-address address-entry"><span class="address-line-2">${addr.addressLine2}</span></p>`
    : '';

  li.innerHTML = `
    <a href="#" data-test="address-select-option-action">
      <div class="vcard checkout-address--static" data-test="static-address">
        <p class="address-entry address-label" style="font-weight:700">${addr.label || ''}</p>
        <p class="fn address-entry">
          <span class="first-name">${addr.firstName} </span>
          <span class="family-name">${addr.lastName}</span>
        </p>
        <p class="address-entry">
          <span class="company-name">${addr.company || ''} </span>
          <span class="tel">${addr.phoneNumber || ''}</span>
        </p>
        <div class="adr">
          <p class="street-address address-entry">
            <span class="address-line-1">${addr.addressLine1}</span>
          </p>
          ${addressLine2Html}
          <p class="address-entry">
            <span class="locality">${addr.city}, </span>
            <span class="region">${addr.state} </span>
            <span class="postal-code">${addr.zipCode}</span>
            / <span class="country-name">${addr.country}</span>
          </p>
        </div>
      </div>
    </a>
  `;

  return li;
}

/**
 * React-safe address update: modifies textContent of child elements
 * inside a [data-test="static-address"] container. Never touches outerHTML.
 */
function updateStaticAddress(staticAddr: Element, addr: ReturnType<typeof toDisplayAddr>) {
  const setText = (selector: string, value: string) => {
    const el = staticAddr.querySelector(selector);
    if (el) el.textContent = value;
  };

  // Insert label if missing
  if (!staticAddr.querySelector('.address-label') && addr.label) {
    const labelP = document.createElement('p');
    labelP.className = 'address-entry address-label';
    labelP.style.fontWeight = '700';
    labelP.textContent = addr.label;
    staticAddr.insertBefore(labelP, staticAddr.firstChild);
  } else {
    setText('.address-label', addr.label || '');
  }

  setText('.first-name', `${addr.firstName} `);
  setText('.family-name', addr.lastName);
  setText('.company-name', `${addr.company || ''} `);
  setText('.tel', addr.phoneNumber || '');
  setText('.address-line-1', addr.addressLine1);
  setText('.locality', `${addr.city}, `);
  setText('.region', `${addr.state} `);
  setText('.postal-code', `${addr.zipCode} / `);
  setText('.country-name', addr.country);
}

/**
 * Updates the dropdown trigger button's static address.
 * Navigates from the dropdown container up to .dropdown--select to find
 * the correct sibling trigger (handles both shipping & billing dropdowns).
 */
function updateDisplayButton(
  dropdownOrForm: Element,
  addr: Parameters<typeof updateStaticAddress>[1],
) {
  // Try to find the trigger relative to the dropdown container first
  const container = dropdownOrForm.closest('.dropdown--select');
  const toggle = container?.querySelector('[data-test="address-select-button"]');
  const staticAddr = toggle?.querySelector('[data-test="static-address"]');
  if (staticAddr) {
    updateStaticAddress(staticAddr, addr);
  } else {
    // eslint-disable-next-line no-console
    console.warn('[updateDisplayButton] Could not find static address in dropdown container');
  }
}

/**
 * Fetches company addresses from the API, then watches for the
 * #addressDropdown element to appear (BigCommerce renders it lazily
 * when the user clicks the address toggle). Once visible, injects addresses.
 */
const CUSTOMER_ID_MAX_RETRIES = 10;
const CUSTOMER_ID_RETRY_DELAY_MS = 2000;

async function getCustomerId(attempt = 1): Promise<number | string | undefined> {
  try {
    const customerData = await getCustomerInfo();
    const id = customerData?.data?.customer?.entityId;
    if (id) return id;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[injectAddresses] Attempt ${attempt}/${CUSTOMER_ID_MAX_RETRIES} failed:`, err);
  }

  if (attempt >= CUSTOMER_ID_MAX_RETRIES) return undefined;

  await new Promise<void>((resolve) => {
    setTimeout(resolve, CUSTOMER_ID_RETRY_DELAY_MS);
  });
  return getCustomerId(attempt + 1);
}

async function injectAddresses() {
  // 1. Get bcCustomerId — retry because B2B/GraphQL proxy may not be ready yet
  const bcCustomerId = await getCustomerId();

  if (!bcCustomerId) {
    // eslint-disable-next-line no-console
    console.warn('[injectAddresses] No bcCustomerId found after all retries');
    return;
  }

  // 2. Fetch addresses from API (do this immediately so data is ready)
  const result = await fetchAllCompanyAddresses(bcCustomerId);
  // Skip injection for non-CCM accounts
  if (result?.success === false) {
    return;
  }

  const addresses = result?.response?.data?.addresses;
  if (!addresses || addresses.length === 0) {
    // eslint-disable-next-line no-console
    console.warn('[injectAddresses] No addresses returned');
    return;
  }

  /**
   * Populates the dropdown element with address items.
   * Called once the #addressDropdown element is found in the DOM.
   */
  function populateDropdown(dropdown: Element) {
    // Avoid double-injection
    if (dropdown.getAttribute('data-addresses-injected') === 'true') return;
    dropdown.setAttribute('data-addresses-injected', 'true');

    // Preserve search box if it exists
    const searchBox = dropdown.querySelector('.b3-address-search-container');
    const searchBoxClone = searchBox ? (searchBox.cloneNode(true) as HTMLElement) : null;

    // Clear dropdown and re-append search box
    while (dropdown.firstChild) {
      dropdown.removeChild(dropdown.firstChild);
    }
    if (searchBoxClone) {
      dropdown.appendChild(searchBoxClone);
    }

    // Inject each address as a list item
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addresses.forEach((rawAddr: any) => {
      const displayAddr = toDisplayAddr(rawAddr);
      const li = buildAddressItem(displayAddr);

      // Click handler: update display, close dropdown, store selection
      li.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Update display button — use dropdown as context to find the correct trigger
        updateDisplayButton(dropdown, displayAddr);

        // Close dropdown
        const container = dropdown.closest('.dropdown--select');
        const trigger = container?.querySelector('[data-test="address-select-button"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');

        const dropdownMenu = dropdown.closest('.dropdownMenu') || dropdown.parentElement;
        if (dropdownMenu) (dropdownMenu as HTMLElement).style.display = 'none';

        // Determine which step this dropdown belongs to
        const isShipping = !!dropdown.closest('.checkout-step--shipping');
        const isBilling = !!dropdown.closest('.checkout-step--billing');
        let stepKey = 'unknown';
        if (isShipping) stepKey = 'shipping';
        else if (isBilling) stepKey = 'billing';

        // Store the FULL API object globally + localStorage (preserves all metadata)
        // @ts-expect-error — custom global for downstream use
        window.b2bSelectedAddress = { ...rawAddr, _step: stepKey };

        // Persist full object in localStorage with separate keys
        if (isShipping) {
          sessionStorage.setItem('b2b-selected-shipping-address', JSON.stringify(rawAddr));
        } else if (isBilling) {
          sessionStorage.setItem('b2b-selected-billing-address', JSON.stringify(rawAddr));
        }
      });

      dropdown.appendChild(li);
    });

    // Setup search filter on the search input (if preserved)
    if (searchBoxClone) {
      const searchInput = searchBoxClone.querySelector('input');
      if (searchInput) {
        // Prevent clicks on the search box from bubbling up to
        // BigCommerce's document-level handler which closes the dropdown.
        ['click', 'mousedown', 'touchstart'].forEach((evt) => {
          searchInput.addEventListener(evt, (e) => {
            e.stopPropagation();
          });
        });
        // Also stop the container div from propagating
        searchBoxClone.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        searchInput.addEventListener('input', () => {
          const query = searchInput.value.toLowerCase();
          const items = dropdown.querySelectorAll('li.dropdown-menu-item');
          items.forEach((item) => {
            const el = item as HTMLElement;
            const text = el.textContent?.toLowerCase() || '';
            el.style.display = text.includes(query) ? '' : 'none';
          });
        });
      }
    }
  }

  // 3. Keep watching for #addressDropdown to appear/reappear in the DOM.
  //    BigCommerce destroys and recreates it every time the user clicks the
  //    dropdown trigger, so we must re-inject each time.
  let lastInjectedDropdown: Element | null = null;

  const dropdownObserver = new MutationObserver(() => {
    const dropdown = document.querySelector('#addressDropdown');
    if (dropdown && dropdown !== lastInjectedDropdown) {
      if (dropdown.closest('.checkout-step--billing')) {
        return;
      }
      lastInjectedDropdown = dropdown;
      populateDropdown(dropdown);
    }
  });

  dropdownObserver.observe(document.body, { childList: true, subtree: true });

  // Also check immediately in case it already exists
  const existing = document.querySelector('#addressDropdown');
  if (existing) {
    if (!existing.closest('.checkout-step--billing')) {
      lastInjectedDropdown = existing;
      populateDropdown(existing);
    }
  }
}

/**
 * Hides the "billing same as shipping" checkbox and handles updating
 * the collapsed shipping step summary with the selected address.
 */
function handleShippingStep(form: Element) {
  // 1. Hide checkbox
  const checkbox = form.querySelector<HTMLInputElement>('[name="billingSameAsShipping"]');
  if (checkbox) {
    const parentField = checkbox.closest('.form-field');
    if (parentField) (parentField as HTMLElement).style.display = 'none';
  }

  // 2. On Continue button click, watch for collapsed step summaries and update them
  const continueBtn = form.querySelector('#checkout-shipping-continue') as HTMLButtonElement | null;
  if (continueBtn) {
    continueBtn.addEventListener('click', () => {
      // @ts-expect-error — custom global
      const selectedAddr = window.b2bSelectedAddress;
      if (!selectedAddr) {
        return;
      }

      // Watch for the collapsed step summary to appear after the step transitions
      const summaryObserver = new MutationObserver(() => {
        // Update shipping step summary
        const shippingStep = document.querySelector(
          '.checkout-step--shipping .stepHeader-body [data-test="static-address"]',
        );
        if (shippingStep) {
          updateStaticAddress(shippingStep, toDisplayAddr(selectedAddr));
          summaryObserver.disconnect();
        }
      });

      summaryObserver.observe(document.body, { childList: true, subtree: true });

      // Safety: disconnect after 15s regardless
      setTimeout(() => summaryObserver.disconnect(), 15000);
    });
  }
}

// ─── Checkout specific JS ───────────────────────────────────────────────────

if (window.location.href.includes('/checkout')) {
  const orderCommentObserver = new MutationObserver(() => {
    const input = document.querySelector<HTMLInputElement>('input[name="orderComment"]');
    if (input && !input.dataset.noteAdded) {
      const note = document.createElement('div');
      note.textContent = 'Add any special instructions for the warehouse team.';
      note.style.marginTop = '0.75rem';
      input.parentNode?.insertBefore(note, input.nextSibling);
      input.dataset.noteAdded = 'true';
      if (orderCommentObserver) {
        orderCommentObserver.disconnect();
      }
    }
  });
  orderCommentObserver.observe(document.body, { childList: true, subtree: true });

  const accCompanyObserver = new MutationObserver(() => {
    const b2bCompanyData = sessionStorage.getItem(`b2b-kobe-company-data`);
    if (b2bCompanyData) {
      const b2bCompany: CompanyState = JSON.parse(b2bCompanyData);

      if (b2bCompany.companyInfo.extraFields) {
        // const businessType = b2bCompany.companyInfo.extraFields.find(
        //   (extraField) => extraField.fieldName.toLowerCase() === 'business type',
        // );
        const hidePriceOnCheckout = checkIfCompanyHasAccessToFeature(
          KOBE_PORTAL_FEATURE_ACCESS.CHECKOUT_HIDE_PRICES_ON_CART,
        );
        // if (businessType && businessType.fieldValue.toLowerCase() === 'collection centre') {
        if (hidePriceOnCheckout) {
          const cart = document.querySelector('[data-test=cart]') as HTMLElement | null;
          if (cart) {
            cart.style.minHeight = 'auto';
          }

          const selectorsToHide = [
            '[data-test=cart-subtotal]',
            '[data-test=cart-shipping]',
            '[data-test=cart-taxes]',
            '[data-test=tax-text]',
            '[data-test=cart-total]',
          ];

          selectorsToHide.forEach((selector) => {
            const el = document.querySelector(selector) as HTMLElement | null;
            if (el) el.style.display = 'none';
          });

          const productList = document.querySelector('.productList') as HTMLElement | null;
          if (productList) productList.style.borderBottom = 'none';

          const paymentUl = document.querySelector(
            '[data-test="payment-form"] .form-fieldset',
          ) as HTMLElement | null;
          if (paymentUl) paymentUl.style.display = 'none';

          const paymentHeader = document.querySelector(
            '.checkout-step--payment .checkout-view-header',
          ) as HTMLElement | null;
          if (paymentHeader) paymentHeader.style.display = 'none';

          const cartItems = document.querySelectorAll('[data-test=cart-item]');
          cartItems.forEach((item) => {
            const productBody = item.querySelector('.product-body') as HTMLElement | null;
            if (productBody) productBody.style.width = '100%';

            const productPrice = item.querySelector(
              '[data-test=cart-item-product-price]',
            ) as HTMLElement | null;
            if (productPrice) productPrice.style.display = 'none';
          });

          // Click checkout continue button if exists (React-safe)
          const continueBtn = document.getElementById(
            'checkout-shipping-continue',
          ) as HTMLButtonElement | null;
          if (continueBtn) continueBtn.click();
        }
      }
    }
  });
  accCompanyObserver.observe(document.body, { childList: true, subtree: true });

  const paymentContinueObserver = new MutationObserver(() => {
    const btn = document.querySelector('#checkout-payment-continue');
    if (btn && btn.textContent && btn.textContent.trim() === 'Place Order') {
      btn.textContent = 'Submit order'; // lowercase "o"
    }
  });

  paymentContinueObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  hideShippingFieldset();
  hideBillingStep();
  if (!window.location.pathname.includes('checkout/order-confirmation')) {
    injectCustomSubmitButton();
  }

  // Start observing
  // observeCheckoutForOrderComments();

  // Run this after the DOM is ready (or after your main observer)
  observeAndHideShippingComments();
  observerQueenslandSignature();
  // observeAndRemoveCartEditLink();
  hidePaymentInstruction();
  watchForAddresses();
  initCartLinkOverride();
  styleSeeAllButton();

  // Address injection + checkbox tracking
  watchShippingStep((form) => {
    injectAddresses();
    handleShippingStep(form);
  });

  // Send address data when the user clicks "Place Order" —
  // must happen BEFORE BigCommerce processes the order so the
  // cart/converted webhook can read it.
  const placeOrderHandled = new WeakSet<Element>();

  const attachPlaceOrderHandler = () => {
    const btn = document.querySelector('#checkout-payment-continue');
    if (!btn || placeOrderHandled.has(btn)) return;
    placeOrderHandled.add(btn);

    btn.addEventListener(
      'click',
      () => {
        const shippingRaw = sessionStorage.getItem('b2b-selected-shipping-address');
        const billingRaw = sessionStorage.getItem('b2b-selected-billing-address');

        if (shippingRaw || billingRaw) {
          const payload = {
            shippingAddress: shippingRaw ? JSON.parse(shippingRaw) : null,
            billingAddress: billingRaw ? JSON.parse(billingRaw) : null,
          };

          sendCustomCartData('selectedAddress', JSON.stringify(payload));
        }
      },
      true,
    ); // capture phase to run before BigCommerce's handler
  };

  // Try immediately (button may already exist)
  attachPlaceOrderHandler();

  // Also watch for React re-renders that swap the button
  const placeOrderObserver = new MutationObserver(() => {
    attachPlaceOrderHandler();
  });

  placeOrderObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (window.location.pathname.includes('checkout/order-confirmation')) {
  localStorage.removeItem('healius-last-cart-vaccines');
  localStorage.removeItem('healius-last-cart-consumables');
  replaceEmail();
  replaceContinueShopping();
  addCommaAfterThankYou();
  replaceConfirmationStatusText();

  // Clean up localStorage (address data was already sent on Place Order click)
  sessionStorage.removeItem('b2b-selected-shipping-address');
  sessionStorage.removeItem('b2b-selected-billing-address');
  sessionStorage.removeItem('b2b-billing-same-as-shipping');
}
